"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertFanApiFactory = void 0;
const generated_1 = require("./generated");
class ApiIndex {
    constructor(alertsApi, tagsApi, silencesApi, historyApi, configurationApi, propertiesApi, schemaApi) {
        this.alertsApi = alertsApi;
        this.tagsApi = tagsApi;
        this.silencesApi = silencesApi;
        this.historyApi = historyApi;
        this.configurationApi = configurationApi;
        this.propertiesApi = propertiesApi;
        this.schemaApi = schemaApi;
    }
}
const AlertFanApiFactory = (axios, basePath) => {
    const alertsApi = new generated_1.AlertsApi(undefined, basePath, axios);
    const tagsApi = new generated_1.TagsApi(undefined, basePath, axios);
    const silencesApi = new generated_1.SilencesApi(undefined, basePath, axios);
    const historyApi = new generated_1.HistoryApi(undefined, basePath, axios);
    const configurationApi = new generated_1.ConfigurationApi(undefined, basePath, axios);
    const propertiesApi = new generated_1.PropertiesApi(undefined, basePath, axios);
    const schemaApi = new generated_1.SchemaApi(undefined, basePath, axios);
    return Object.freeze(new ApiIndex(alertsApi, tagsApi, silencesApi, historyApi, configurationApi, propertiesApi, schemaApi));
};
exports.AlertFanApiFactory = AlertFanApiFactory;
//# sourceMappingURL=api.js.map